export const PROGRAMS = "/v2/programs";
export const PROGRAM_BY_ID = (id) => `/v2/programs/${id}`;

export const ACTIVITIES = "/v2/activities";
export const ACTIVITY_BY_ID = (id) => `/v2/activities/${id}`;

export const AGE_CATEGORIES = `/v2/selects/age-categories`;
export const NGO_RELATED_SERVICES = `/v2/selects/ngo-related-services`;
